import { useEffect, useState } from 'react'
import api from '../services/api'

// Filiação (TMOTFIL, frota.motfil): pais, cônjuge e estado civil do funcionário

interface Form {
  motnompai: string; motdocpai: string; motnommae: string; motdocmae: string
  motnomcon: string; motdoccon: string; motestciv: string
}

const ESTADOS_CIVIS: [string, string][] = [['S', 'Solteiro'], ['C', 'Casado'], ['D', 'Divorciado'], ['V', 'Viúvo'], ['O', 'Outro']]

const largura = (max: number) => Math.max(56, max * 9 + 28)
const LINHA: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', gap: '0.75rem 0.9rem', alignItems: 'flex-end' }

const campo = (w: number, label: string, conteudo: React.ReactNode) => (
  <div className="field-cad" style={{ flex: `0 0 ${w}px` }}>
    <label style={{ whiteSpace: 'nowrap' }}>{label}</label>
    {conteudo}
  </div>
)

export default function FuncionarioFiliacaoModal({ motcod, motnome, onClose, onSalvo }: {
  motcod: string; motnome: string; onClose: () => void; onSalvo?: (estadoCivil: string) => void
}) {
  const [f, setF] = useState<Form | null>(null)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function carregar() {
    const r = await api.get(`/funcionarios/${encodeURIComponent(motcod)}/filiacao`)
    setF({ ...r.data, motestciv: r.data.motestciv || 'S' })
  }

  useEffect(() => {
    carregar().catch(() => setErro('Não foi possível carregar a filiação.'))
  }, [motcod])

  async function salvar() {
    setErro(''); setAviso('')
    setSalvando(true)
    try {
      const r = await api.put(`/funcionarios/${encodeURIComponent(motcod)}/filiacao`, f)
      await carregar()
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : 'Filiação salva.')
      if (!r.data?.semAlteracao) onSalvo?.(f!.motestciv)
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar a filiação.')
    } finally {
      setSalvando(false)
    }
  }

  const set = (c: keyof Form, v: string) => setF(p => ({ ...p!, [c]: v }))
  const txt = (c: keyof Form, label: string, max: number) =>
    campo(Math.max(largura(max), label.length * 7 + 10), label,
      <input value={f![c]} maxLength={max} style={{ width: '100%', boxSizing: 'border-box' }}
        onChange={e => set(c, e.target.value.toUpperCase())} />)

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 640, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header" style={{ gap: '1rem' }}>
          <div style={{ minWidth: 0 }}><h2>{`Filiação — ${motcod} · ${motnome}`}</h2></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>TMOTFIL</span>
            <button className="modal-fechar" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="modal-corpo">
          {!f ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <>
              <div style={LINHA}>
                {txt('motnompai', 'Nome do pai', 40)}
                {txt('motdocpai', 'Documento', 12)}
              </div>
              <div style={{ ...LINHA, marginTop: '0.75rem' }}>
                {txt('motnommae', 'Nome da mãe', 40)}
                {txt('motdocmae', 'Documento', 12)}
              </div>
              <div style={{ ...LINHA, marginTop: '0.75rem' }}>
                {txt('motnomcon', 'Nome do Cônjuge', 40)}
                {txt('motdoccon', 'Documento', 12)}
              </div>
              <div style={{ ...LINHA, marginTop: '0.75rem' }}>
                {campo(150, 'Estado Civil',
                  <select value={f.motestciv} style={{ width: '100%', boxSizing: 'border-box' }} onChange={e => set('motestciv', e.target.value)}>
                    {ESTADOS_CIVIS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>)}
              </div>
            </>
          )}

          {f && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '1rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '1rem 0 0' }}>{aviso}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
          <button className="btn btn-orange" onClick={salvar} disabled={salvando || !f}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  )
}
